import {RootState} from '../store';

export const scheduleMaintenanceData = (state: RootState) => state.scheduleMaintenance.scheduleMaintenance;
export const maintenanceLoading = (state: RootState) => state.scheduleMaintenance.isLoading;
